import { useDispatch, useSelector } from "react-redux";
import { RootState, AppDispatch } from "../redux/store";
import { closeMenu, openMenu } from "../redux/slices/menuTogglerSlice";

export const useMenuToggler = () => {
  const dispatch = useDispatch<AppDispatch>();
  const isOpen = useSelector((state: RootState) => state.menuToggler.isOpen);

  const handleOpenMenu = () => {
    dispatch(openMenu());
  };

  const handleCloseMenu = () => {
    dispatch(closeMenu());
  };

  return {
    isOpen,
    openMenu: handleOpenMenu,
    closeMenu: handleCloseMenu,
  };
};
